import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ContactSection from "../components/Contact/ContactSection";
import ContactForm from "../components/ContactSection";
import Map from "../components/Contact/Map";
import AboutBanner from "../components/AboutBanner";


const Home = () => {
  return (
    <main className="homepage">
      <Header />
      <AboutBanner
  title="Contact Us"
  subtitle="We are here to assist you!"
/>
  <ContactSection />
  <ContactForm />
  <Map />
  <Footer /> 
    </main>
  );
};

export default Home;
